import React from 'react';

const Footer = () => {
    let fcss = {
        backgroundColor: '#333',   
        color: '#fff',    
        padding: '20px 0',    
        marginTop: '80px',    
        marginBottom: '0'

      }

    return (
        <div>
           <p style={fcss}>COPYRIGHT(C) 2022 Nike, Inc. All Rights Reserved</p> 
        </div>
    );
};

export default Footer;